import React from "react";

function PrivacyPolicy() {
  return (
    <div className="page__width mt-20">
      <h1 className="text-4xl mb-4 text-main-green">Политика за поверителност</h1>
      <p className="text-sm mb-2 text-body">
        Taзи пoлитикa ce oтнacя дo използването и обработката на лични данни в
        yeб caйт premiumservices.bg, собственост на „Премиум сървисес“ ООД,
        споменавано още като “Ние” по-надолу. Политиката за защита на личните
        данни има за цел да разясни как и защо събираме и обработваме Вашите
        лични данни. „Лични данни“ е наименование за всяка информация или набор
        от информация, която Ви или може да Ви идентифицира в комбинация с друга
        информация. Такъв тип е информацията, която споделяте с нас, изборът Ви
        в уеб сайта premiumservices.bg, изборът, относно маркетинговите
        съобщения, които желаете да бъдат изпратени до Вас и други. Политика
        разяснява и как обработваме Вашите лични данни, какви са Вашите права и
        законови защити. Задължителна информация за правата на лицата по защита
        на личните данни: Дружество, носещо отговорност за събиране и обработка
        на Вашите лични данни: Дружество: „Премиум сървисес“ ООД
      </p>
      <li className="text-sm text-body mb-2 list-none">
      ЕИК/БУЛСТАТ: 207511526
    </li>
      <li className="text-sm text-body mb-2 list-none">
      Седалище и адрес на управление: гр. Пловдив, ул.“Средец” № 77, ет. 4, ап. 13
      </li>
      <li className="text-sm text-body mb-2 list-none">
      Компетентен контролен орган по защита на личните данни: Дружество: КЗЛД
      </li>
      <li className="text-sm text-body mb-2 list-none">
      Седалище и адрес на управление: гр. София 1592, бул. „Проф. Цветан Лазаров” 2
      </li>
      <li className="text-sm text-body mb-2 list-none">
      Адрес за кореспонденция: гр. София 1592, бул. „Проф. Цветан Лазаров” 2 
      </li>
      <li className="text-sm text-body mb-2 list-none">
      Телефон: 02/ 915 3 518 
      </li>
      <li className="text-sm text-body mb-2 list-none">
      Уеб сайт: www.cpdp.bg
      </li>
      <p className="text-sm mb-2 text-body">Събиране, обработка и съхранение на Вашите лични данни –
      същност Ние (Администратор) събираме, обработваме и съхраняваме Вашите
      лични данни въз основа на използването на уеб сайта ни, достъпен на адрес
      https://premiumservices.bg и за да отговорим на Вашите изисквания за
      достъп до качествени услуги, предоставяне на достъп до определени
      функционалности на уеб сайта, регистрация за имейл бюлетин и/или
      организирани от нас събития, участия в онлайн проучвания, дискусионни
      групи или форуми, за маркетингови дейности. „Премиум сървисес“ ООД
      (Администратор) събира, обработва, съхранява и защитава Вашите лични
      данни, съобразено с Регламент (ЕС) 2016/679 (GDPR).<br/>Администрираме Вашите
      лични само след Вашето изрично съгласие за: Изпълнението на задълженията
      ни по сключен договор; Легитимни наши (Администратор) или на трети страни
      интереси, като например изпълнение на задължения към;– КЗЛД– НАП– МВР–
      Други Предоставяне на пълна функционалност при използването на уеб сайта;
      Счетоводни цели; Статистически цели; Маркетингови цели; Изпращане на
      информационен/маркетингов бюлетин след изрично съгласие; Осъществяване на
      връзка с потребител/клиент; 
      </p>
      <h2 className="text-2xl mb-4 text-main-green">Начини на получаване на лични данни</h2>
      <p className="text-sm mb-2 text-body">Ние
      (Администратор) събираме, обработваме и съхраняваме Вашите лични данни
      законосъобразно, добросъвестно и прозрачно. Можем да получим Вашите лични
      данни след доброволното им предоставяне чрез: Изпращане на писмо чрез
      имейл; Попълване на бриф; Участие в наши промоции, игри и други събития;
      Изпращане на обратна връзка; Предоставяне на „Оферта“ Сключване на
      „Договор“ за предоставяне на Услуги, описани надлежно в Общи условия и
      достъпни на уеб адрес <a className="underline text-main-gold" href="premiumservices.bg/terms">https://premiumservices.bg/terms</a>; Тип лични
      данни, които се събират Ние (Администратор) събираме, обработваме и
      съхраняваме следният тип лични данни: Данни за вас: Име, ЕГН; Данни за
      контакт: Имейл адрес; Данни за местонахождение: Адрес на местоживеене,
      адрес за кореспонденция; Финансови данни: Данни за банкови сметки и данни
      за издаване на данъчна фактура; Маркетингови и комуникационни данни:
      Вашите предпочитания за получаване на маркетингови съобщения от нас, както
      и комуникационни предпочитания; История на посещение: Проследяваме
      интересите Ви, за да установим типа съдържание, който предпочитате; IP
      адрес; 
      <br/>Ние (Администратор) НЕ събираме чувствителни лични данни за Вас:
      Расови; Етническа принадлежност; Религиозни убеждения; Сексуална
      ориентация; Политически възгледи; Членство в организации; Информация за
      здравословно и генетично състояние; Биометрични данни; Наказателна
      отговорност;
      </p>
      <h2 className="text-2xl mb-4 text-main-green">Бисквитки</h2>
      <p className="text-sm mb-2 text-body">
      Биcквиткитe ca фaйлoвe c инфopмaция,
      включвaщи нeoгpaничeнo тeкcтoвo cъдъpжaниe, кoитo ce cъxpaнявaт в
      кoмпютpитe нa пoтpeбитeля c цeл пoдoбpявaнe paбoтaтa cъc cъoтвeтния yeб
      caйт. Teзи фaйлoвe пoзвoлявaт пoтpeбитeлят дa бъдe paзпoзнaт и yeб caйтът
      дa бъдe aдaптиpaн cпpямo нeгoвитe пpeдпoчитaния. Биcквиткитe oбикнoвeнo
      cъдъpжaт имeтo нa yeб caйтa, към кoйтo пpинaдлeжaт, вpeмeтo, зa кoeтo ce
      cъxpaнявaт нa кoмпютъpa нa пoтpeбитeля, и yникaлeн нoмep.
      </p>
      <h2 className="text-2xl mb-4 text-main-green">Цели</h2>
      <p className="text-sm mb-2 text-body">
      Биcквиткитe ce изпoлзвaт зa aдaптиpaнe cъдъpжaниeтo нa yeб caйта към
      пpeдпoчитaниятa нa индивидyaлния пoтpeбитeл и oптимизиpaнe paбoтaтa c
      oпpeдeлeния yeб caйт. Изпoлзвaт ce oщe зa изгoтвянeтo нa aнoнимнa oбщa
      cтaтиcтикa, кoятo ни пoмaгa дa paзбepeм кaк пoтpeбитeлят paбoти c yeб
      caйтoвeтe, кoeтo пoмaгa зa пoдoбpявaнeтo нa тяxнaтa cтpyктypa и
      cъдъpжaниe, кaтo в cъщoтo вpeмe нямa дocтъп дo личнaтa пoтpeбитeлcкa
      инфopмaция. Cъдъpжaние на лични данни: Личнaтa инфopмaция, ĸoятo ce
      aкyмyлиpa чpeз бисквитките, мoжe дa бъдe изпoлзвaнa caмo зa извъpшвaнe нa
      oпpeдeлeни oпepaции зa пoтpeбитeля. Taкaвa инфopмaция ce кpиптиpa пo
      нaчин, кoйтo пpaви дocтъпa дo нeя oт нeoтopизиpaни лицa нeвъзмoжeн.
      </p>
      <h2 className="text-2xl mb-4 text-main-green">Изтpивaнe</h2>
      <p className="text-sm mb-2 text-body">
      Πo пpaвилo aпликaциитe, изпoлзвaни зa cъpфиpaнe в yeб caйтoвe,
      пoзвoлявaт зaпaзвaнeтo нa биcквитки пo пoдpaзбиpaнe. Taзи нacтpoйкa мoжe
      дa бъдe пpoмeнeнa тaкa, чe aвтoмaтичнoтo зaпaмeтявaнe нa биcквитки дa бъдe
      блoкиpaнo в yeб бpayзъpa или пoтpeбитeлят дa бъдe инфopмиpaн вceки път,
      пpeди биcквиткитe дa бъдaт зaпaмeтeни нa кoмпютъpa. Дeтaйлнa инфopмaция зa
      paзличнитe нaчини зa paбoтa c биcквитки мoжe дa бъдe oткpитa в нacтpoйкитe
      нa aпликaциятa / yeб бpayзъpa. Oгpaничaвaнeтo нa биcквиткитe мoжe дa ce
      oтpaзи нa някoи фyнкциoнaлнocти нa yeб caйтa. Целите, за които използваме
      бисквитките, са най-основно следене на поведението ви в следните
      направления: Проследяване на части от уеб сайта, които посещавате; Колко
      време отделяте при посещение в уеб сайта; Колко време гледате дадено
      видео; Реклами, които сте видели и/или с които сте взаимодействали;
      </p>
      <h2 className="text-2xl mb-4 text-main-green">Споделяне на Вашите лични данни</h2>
      <p className="text-sm mb-2 text-body">
      Част от информацията, която получаваме от и за Вас, понякога се споделя с трети страни. Това е наложително, за да
      можем да осигурим най-доброто преживяване при използване на нашите услуги.
      Понякога, за да можем да осигурим наличност и достъпност на използваната
      от Вас услуга. „Интерактив Орб“ ООД като отговорен администратор на Вашите
      лични данни не разкрива, не продава, не споделя лични данни за Вас (по
      смисъла на Регламент (ЕС) 2016/679 (GDPR)) с други лица и/или несвързани
      компании, освен ако това не е наложително, за да Ви представим заявена от
      Вас услуга и само след Вашето изрично съгласие, или когато: Информацията
      се споделя с доверени партньори, с цел предоставянето на адекватна
      рекламна комуникация към потребителите ни, както и за предоставяне на
      нужната информация за изпълнение и създаване на офертни предложения.
      Компаниите партньори нямат права да споделят въпросната информация
      самостоятелно. Такива компании са, но не само: Google (Google Analytics;
      Google Tag Manager и др.); Facebook (Facebook Pixel; Facebook Ads и др.);
      Mailchimp(mailchimp.com) – софтуер за имейл маркетинг кампании
      Информацията се използва за целите на изпълнение на легитимни заявки от
      правомощни органи по смисъла на българското законодателство; Начини и
      срокове за съхранение на лични данни Вашите лични данни се съхраняват на
      сървър с ограничен достъп. Сроковете, за които съхраняваме лични данни за
      Вас са съответно: Докато не заявите изричното си желание Вашите лични
      данни да бъдат изтрити; В срока на валидност на активните бисквитки; Права
      при събиране. обработка и съхранение на лични данни на субект по смисъла
      на Регламент (ЕС) 2016/679 (GDPR)
      </p>
      <h2 className="text-2xl mb-4 text-main-green">Право на достъп до лични данни</h2>
      <p className="text-sm mb-2 text-body">
      Имате правото да получите потвърждение от наша страна, че обработваме Ваши лични
      данни. Ако случаят е такъв, имате право на достъп до съответната
      информация; Право на корекции на лични данни: Имате правото да коригирате
      или заявите попълване на неточните или непълните лични данни, свързани с
      Вас с отправяне на искане до нас.
      </p>
      <h2 className="text-2xl mb-4 text-main-green">Право на изтриване на лични данни</h2>
      <p className="text-sm mb-2 text-body">
      Имате правото да поискате от нас изтриване
      на част или всички свързани с Вас лични данни, а ние имаме задължението да
      ги изтрием без ненужно забавяне, при определени обстоятелства; Право на
      ограничаване: Имате право да изискате да ограничим обработването на
      личните Ви данни при определени обстоятелства и докато не бъде открито
      легитимно решение; 
      </p>
      <h2 className="text-2xl mb-4 text-main-green">Право на възражение</h2>
      <p className="text-sm mb-2 text-body">
      Имате правото да възразите срещу
      обработване на личните Ви данни в дадена ситуация, като например да имате
      съмнение в легитимния интерес на обработка от наша страна (Администратор);
      Право на преносимост: Имате правото да изискате от нас (Администратор) да
      Ви предоставим Вашите лични данни в подходящ вариант с цел прехвърляне към
      друг администратор, ако личните Ви данни се обработват автоматизирано,
      след Вашето изрично съгласие и/или за изпълнение на договорни отношения с
      нас (Администратор); 
      </p>
      <h2 className="text-2xl mb-4 text-main-green">Право на подаване на оплакване</h2>
      <p className="text-sm mb-2 text-body">
      Имате правото да
      подадете оплакване (жалба) по отношение на обработката на Вашите лични
      данни от наша страна (Администратор) в съответния контролен орган;
      </p>
      <li className="text-sm text-body mb-2 list-none">
      Компетентен контролен орган по защита на личните данни: Дружество: КЗЛД
      </li>
      <li className="text-sm text-body mb-2 list-none">
      Седалище и адрес на управление: гр. София 1592, бул. „Проф. Цветан Лазаров” 2
      </li>
      <li className="text-sm text-body mb-2 list-none">
      Адрес за кореспонденция: гр. София 1592, бул. „Проф. Цветан Лазаров” 2 
      </li>
      <li className="text-sm text-body mb-2 list-none">
      Телефон: 02/ 915 3 518 
      </li>
      <li className="text-sm text-body mb-2 list-none">
      Уеб сайт: www.cpdp.bg
      </li>
      <p className="text-sm mb-2 text-body">
      <br/>При желание да упражните част или всичките
      си права, свързани с настоящата политика за поверителност, моля, обърнете
      се към нас на имейл адрес: premium.services.plovdiv@gmail.com
      </p>
    </div>
  );
}

export default PrivacyPolicy;
